import { onActionError, onDeleteError, onFormError } from '../../core/utils/hooks'
import { notification } from 'antd'

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  load,
  acceptTask,
  rejectTask,
  negotiateTask,
  completeTask
} from '../../api/vendor/job'

const key = 'vendor.jobs'

export const useFetch = (id) => {
  return useQuery({
    queryKey: [key, id],
    queryFn: () => load(id),
    onError: onActionError
  })
}

export const useAcceptTask = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => acceptTask(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key, id])

      notification.success({
        message: 'Updated',
        description: 'The Task was accepted'
      })
    },
    onError: onActionError
  })
}

export const useRejectTask = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => rejectTask(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key, id])

      notification.success({
        message: 'Updated',
        description: 'The Task was rejected'
      })
    },
    onError: onActionError
  })
}

export const useNegotiateTask = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => negotiateTask(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key, id])

      notification.success({
        message: 'Updated',
        description: 'The Task was updated'
      })
    },
    onError: onActionError
  })
}

export const useCompleteTask = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => completeTask(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key, id])

      notification.success({
        message: 'Updated',
        description: 'The Task was updated'
      })
    },
    onError: onActionError
  })
}
